import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { useLayout } from '../../Hooks/useLayout'

const Profile = () => {
	const { user } = useAuth()
	const layout = useLayout()
	const navigate = useNavigate()

	useEffect(() => {
		if (!user) {
			// Redirect to login if no user
			navigate('/auth/login')
			return
		}

		// Redirect to role-specific profile page
		switch (user.role) {
			case 'Admin':
				navigate(`/admin/profile/${layout}`)
				break
			case 'Instructor':
				navigate(`/instructor/profile/${layout}`)
				break
			case 'Student911':
				navigate(`/student911/profile/${layout}`)
				break
			case 'Student12':
				navigate(`/student12/profile/${layout}`)
				break
			case 'Parent':
				navigate(`/parent/profile/${layout}`)
				break
			default:
				// Fallback to a generic profile or show error
				console.error('Unknown user role:', user.role)
				break
		}
	}, [user, layout, navigate])

	// Show loading while redirecting
	return (
		<div className="text-center p-5">
			<div className="spinner-border text-primary" role="status">
				<span className="sr-only">Redirecting to profile...</span>
			</div>
			<p className="mt-3">Redirecting to your profile...</p>
		</div>
	)
}

export { Profile }
